import {PuiButton} from "@portnet/ui";
import React from "react";

const AppButton = React.forwardRef((props, ref) => {
  return <PuiButton ref={ref} {...props} />;
});

export default AppButton;
